var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { useRevalidator, useLoaderData } from 'react-router';
import { useSetAtom } from 'jotai';
import { Translate } from "../../../../../../../I18N";
import * as entitiesAPI from "../../../../../../api/paragraphExtractor/entities";
import { Button, ConfirmationModal } from "../../../../../../Components/UI";
import { notificationAtom } from "../../../../../../atoms";


const ExtractEntitiesDialog = ({
  setIsProcessing,
  disabled,
  onSuccess,
  selected





}) => {
  const { extractor } = useLoaderData();
  const revalidator = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);
  const [isOpen, setIsOpen] = useState(false);

  // eslint-disable-next-line max-statements
  const handleExtract = async () => {
    setIsProcessing(true);

    try {
      if (!extractor) {
        setNotifications({
          type: 'error',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
          details: /*#__PURE__*/_jsx(Translate, {}, void 0, "Cannot find extractor")
        });
      } else {
        await entitiesAPI.extractSelected(extractor === null || extractor === void 0 ? void 0 : extractor._id, selected);
        await revalidator.revalidate();
        setIsOpen(false);
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/
          _jsx(Translate, {}, void 0, "The process of extracting the paragraphs has successfully started. Check the Status column for updates on the process."


          )

        });
        onSuccess();
      }
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred")
      });
    }

    setIsOpen(false);
    setIsProcessing(false);
  };

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      className: "disabled:opacity-50",
      disabled: disabled,
      onClick: () => setIsOpen(true) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Extract paragraphs")
    ),
    isOpen && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Are you sure?"),
      warningText: /*#__PURE__*/
      _jsx(Translate, {}, void 0, "All of the previously created paragraphs will be deleted and recreated after the process."


      ),

      acceptButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Continue"),
      cancelButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "No, cancel"),
      onAcceptClick: handleExtract,
      onCancelClick: () => setIsOpen(false) }
    )

    ));

};

export { ExtractEntitiesDialog };